module.exports = ".button-set:last-child {\n  margin-right: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/buttons-handler/alert-modal/alert-modal.component.scss
// module id = ./shared/components/common/buttons-handler/alert-modal/alert-modal.component.scss
// module chunks = 0